import React, { useEffect, useRef } from "react";
import { Junction } from "./queries/types";
import { GetJunctionNodeForMultiple } from "./queries/queries";
import { useLazyQuery } from "@apollo/client";
import { EnvAccessType } from "../../../../../../utils/constants";
import { Button } from "../../../../../../stories/Button/Button";
import { useReactToPrint } from "react-to-print";
import TransformImage from "../../../../../../images/transForm.png";
import TransformLogo from "../../../../../../images/TransformLogo.svg";
import EduateLogo from "../../../../../../images/EduateLogo.svg";
import ArcadisLogo from "../../../../../../images/Arcadis_Logo.png";
import { QRCodeSVG } from "qrcode.react";
import PhoneImage from "../../../../../../images/call.svg";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  selectedJunctions: number[];
}

export interface nodeVar {
  ids: number[];
  token?: string;
}

const PrintJunctionDetails = ({ setModalFlag, selectedJunctions }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const [GetJunctionByNode, { data }] = useLazyQuery<
    { nodes: Junction[] },
    nodeVar
  >(GetJunctionNodeForMultiple);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedJunctions) {
          GetJunctionByNode({
            variables: {
              ids: [...selectedJunctions],
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetJunctionByNode, selectedJunctions]);
  const reactToPrintFn = useReactToPrint({ contentRef });

  let Front_End_URI = "";

  switch (process.env.React_App_access_type) {
    case EnvAccessType.PROD:
      Front_End_URI = process.env.React_App_PROD_Front_End_Point ?? "";
      break;

    case EnvAccessType.DEV:
      Front_End_URI = process.env.React_App_UAT_Front_End_Point ?? "";
      break;
  }

  return (
    <>
      <div className="print-junction">
        <style type="text/css" media="print" scoped>
          {`
      @page {
     height: 4in;
    width: 6in;
    margin: 0;
  }
  body {
    margin: 0;
  }
  .print-junction__data{
   height: 4in;
    width: 6in;
    margin:0
  }
.print-junction__block{
height:100%;
margin:0
}
.phone-image{
width:20px;
height:20px;
}
  `}
        </style>
        <div className="print-junction__data" ref={contentRef}>
          {data
            ? data.nodes.map((res: Junction) => {
                return (
                  <div className="print-junction__block">
                    <div className="print-junction__block--data">
                      <div className="print-junction__block--flex">
                        <div className="print-junction__block--transform">
                          <img src={TransformImage} alt="" />
                        </div>
                        <div className="print-junction__block--title">
                          <b>{res.customer.name}</b>
                        </div>
                      </div>
                     
                      <div className="print-junction__block--junction">
                        <div className="print-junction__block--junction--grid">
                          <span>Traffic Signal ID </span>
                          <span>:</span>

                          <b>{res.code}</b>
                          <span>Junction Name</span>
                          <span>:</span>
                          <b className="print-junction__block--junction--name">
                            {res.name}
                          </b>

                          <span>Helpdesk <img src={PhoneImage} alt="" className="phone-image"/></span>
                          <span>:</span>
                          <b>080 2294 2926</b>
                        </div>

                        <div className="print-junction__block--junction--helpdesk">
                          <b>Scan for Signal Detail</b>
                          {Front_End_URI && res.id && (
                            <QRCodeSVG
                              value={`${Front_End_URI}/${res.id}/junctiondata`}
                              className="print-junction__block--url"
                              level="H"
                              imageSettings={{
                                src: TransformLogo,
                                x: undefined,
                                y: undefined,
                                height: 30,
                                width: 30,
                                excavate: true,
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="print-junction__block--powered-by">
                        <div>
                          <img src={TransformLogo} alt="" />
                          <b>TRANSFORM</b>
                        </div>

                        <div>
                          <img src={ArcadisLogo} alt="" /> ARCADIS
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>

        <div></div>
      </div>

      <Button mode="print" onClick={reactToPrintFn} />

      <Button
        mode="cancel"
        onClick={() => {
          setModalFlag(false);
        }}
      />
    </>
  );
};

export default PrintJunctionDetails;
